<template>
  <div class="solution-detail-bkg" v-if="detail">
    <!-- 微信认证组件 -->
    <wxAuth :share="share" ref="child" @callback="shareFinish"></wxAuth>
    <div ref="homeHeader" class="home-header">
      <!-- title -->
      <headers :params="hraderP"></headers>
    </div>
    <div v-if="!isNativeApp" style="height: 1.226667rem;"></div>
    <!-- 搜索框 -->
    <div class="fiexd" :style="{ top: isNativeApp ? 0 : 1.226667 + 'rem' }">
      <search :param="searchParam"></search>
    </div>
    <div style="height: 1.226667rem;"></div>
    <van-row class="solution-detail-row">
      <van-col :span="24" class="item-title">{{ detail.solutionName }}</van-col>
    </van-row>
    <van-row class="solution-detail-row solution-first-row">
      <van-col :span="5" class="item-type" v-if="buildingType && buildingType !== ''">
        <router-link :to="`/solutions/list.html?buildingTypeId=${buildingTypeId}&buildingType=${buildingType}`">
          {{ buildingType }}
        </router-link>
      </van-col>
      <van-col :span="5" class="item-type" v-else-if="detail.buildingType">
        <router-link
          :to="`/solutions/list.html?buildingTypeId=${detail.buildingType.id}&buildingType=${detail.buildingType.name}`">
          {{ detail.buildingType.name }}
        </router-link>
      </van-col>
      <van-col :span="10" class="item-type" v-if="firstSysAttr">
        <router-link :to="`/solutions/list.html?firstSysAttrId=${firstSysAttrId}&firstSysAttr=${firstSysAttrId}`">
          {{ firstSysAttr }}
        </router-link>
      </van-col>
      <van-col :span="10" class="item-type" v-else-if="detail.firstSysAttr">
        <router-link
          :to="`/solutions/list.html?firstSysAttrId=${detail.firstSysAttr.id}&firstSysAttr=${detail.firstSysAttr.name}`">
          {{ detail.firstSysAttr.name }}
        </router-link>
      </van-col>
      <van-col :span="9" class="item-type-date">{{ detail.shelveTime }}</van-col>
    </van-row>

    <van-row class="solution-detail-row item-describe-price"
      :style="{ paddingTop: (detail.charges || detail.charges > 0) ? 10 + 'px' : 0 + 'px', paddingBottom: (detail.charges || detail.charges > 0) ? 10 + 'px' : 0 + 'px' }">
      <van-col v-if="detail.seckillFlag" :span="24" class="item-price">本方案原价{{ detail.charges }}元，秒杀仅需<span
          style="color:red">{{ detail.seckill }}</span>元，即可下载完整资料</van-col>
      <template v-else-if="showLimitFree && (detail.charges || detail.charges > 0)">
        <van-col :span="24" class="item-price">本方案为付费方案，原价￥<span style="color:red">{{ money }}</span></van-col>
        <van-col :span="24" class="item-limitFree">当前<span style="color:red">限时免费</span>中，限免倒计时<span
            style="color:red">{{ day }}</span>天<span style="color:red">{{ hour }}</span>小时<span
            style="color:red">{{ min }}</span>分钟<span style="color:red">{{ second }}</span>秒</van-col>
      </template>
      <van-col v-else-if="!showLimitFree && (detail.charges || detail.charges > 0)" :span="24"
        class="item-price">本方案为付费方案，可免费预览全部内容，仅需￥<span style="color:red">{{ money }}</span>元，即可下载完整方案</van-col>
    </van-row>
    <van-row class="solution-detail-row item-describe-row">
      <van-col :span="24" class="item-describe">{{ detail.description }}</van-col>
    </van-row>
    <van-row class="solution-detail-row-label margin-top-10">
      <van-col :span="24" class="item-label read">附件预览<span class='span'>{{ detail.pageView | myriabit }}</span> <span
          class='span1'>阅读量</span></van-col>
    </van-row>
    <van-row class="solution-detail-row solution-detail-row-fils">
      <van-col :span="24" class="item-img" ref="vanCol">
        <div ref="vanImg" v-if="previewUrls">
          <!--          <img v-for="img of detail.pics" :key="img.id" :src="img.url | getImageUrl" @click="preview(img.url)" width="100%" alt="">-->
          <iframe
            :src="'https://preview.homedo.com/view?src=' +
              encodeURIComponent(previewUrls) +
              '&watermark=' + encodeURIComponent(watermark) + '&fontsize=14px&img=false&pdf=false&printable=false&limit=' + limit"
            width="94%" height="500px" frameborder="1" />
        </div>
      </van-col>
      <!-- <van-col :span="24" class="read"><span>{{detail.pageView | myriabit}}</span> 阅读量</van-col> -->
      <van-col :span="24" v-if="showChek" class="chek" :class="{ 'chek--disabled': isPreviewProtected }"
        @click="chekMore"><img src="../../assets/images/chek.png" :class="{ 'img': showImgList }"
          style="width:18px;margin:14px 5px;vertical-align:middle;" /><span>{{ showImgList ? '查看更多' : '收起' }}</span></van-col>
    </van-row>
    <van-row class="solution-detail-row-label">
      <van-col :span="16" class="item-label">方案附件</van-col>
      <van-col :span="8" class="batch_download">
        <!-- 允许下载 && 免费 || 限免 -->
        <span
          v-if="(detail.isAdmitDownload && (!detail.charges || detail.charges <= 0)) || detail.activityFreeStatus === 'PROCEED'"
          @click="handleBatchDownload">打包下载</span>
      </van-col>
    </van-row>
    <van-row class="solution-detail-row-pdf" v-for="(item, index) of detail.bizFiles" :key="index">
      <p class="item-file-or-brand" @click="handleAttachmentClick(item, index)">{{ item.name }}</p>
    </van-row>
    <template v-if="detail.brandFirm">
      <van-row class="solution-detail-row-label">
        <van-col :span="24" class="item-label">方案提供商</van-col>
      </van-row>
      <van-row class="solution-detail-row-pdf">
        <van-col :span="19" class="item-file-or-brand">{{ detail.brandFirm.firmName }}</van-col>
        <van-col :span="5" class="item-brand-right"><router-link
            :to="`/user/index/${detail.brandFirm.userId}.html`">进入主页 &gt;</router-link></van-col>
      </van-row>
    </template>

    <div class="public-header" v-if="params.list.length > 0">
      <div class="public-header-left">推荐方案</div>
    </div>
    <list :params="params"></list>
    <!-- 与底部浮动按钮高度一致 -->
    <div class="bottom-style"></div>
    <van-row class="sub-demand">
      <van-col :span="8" class="sub-demand-collection">
        <div v-if="!showIcon">
          <img @click="collection(1)" src="../../assets/images/icon.png" />
          <span @click="collection(1)">收藏</span>
        </div>
        <div v-else>
          <img @click="collection(2)" src="../../assets/images/icon1.png" />
          <span @click="collection(2)">已收藏</span>
        </div>
      </van-col>
      <van-col :span="8" class="sub-demand-kefu">
        <img @click="kefu" src="../../assets/images/icon_p.png" />
        <span @click="kefu">客服</span>
      </van-col>
      <van-col :span="12">
        <router-link to="/demand/add.html"><button class="sub-demand-btn">发起设计需求</button></router-link>
      </van-col>
      <van-col v-if="isOverAjax" :span="12">

        <button class="sub-download-btn" v-if="detail.seckillFlag" @click="updownloadBtn">下载源文件</button>
        <button class="sub-download-btn"
          v-else-if="(detail.isAdmitDownload && (!detail.charges || detail.charges <= 0))"
          @click="handleBatchDownload">免费下载</button>
        <button class="sub-download-btn" v-else-if="detail.isAdmitDownload && detail.activityFreeStatus === 'PROCEED'"
          @click="handleBatchDownload">限免中 去下载</button>
        <button class="sub-download-btn" v-else-if="!(+detail.isAdmitDownload)">只可预览</button>
        <button class="sub-download-btn" v-else @click="updownloadBtn">下载源文件</button>
      </van-col>
    </van-row>
    <!-- 下载次数上限-提示 -->
    <download-limit ref="downloadLimit"></download-limit>
    <share-guide-mask ref="shareGuide" :biz-id="solutionId" :active-id="detail.activityId"></share-guide-mask>
    <share-guide-dialog ref="shareGuideDialog" @callback="shareGuideDialogCallback"></share-guide-dialog>
    <van-overlay :show="showMiniProgramShare" @click="closeMiniProgramShare">
      <div class="mini-program-share" @click.stop>
        <div class="mini-program-share__title">分享到</div>
        <div class="mini-program-share__options">
          <button class="mini-program-share__option" @click="shareToMiniProgram('friend')">
            <span class="mini-program-share__icon mini-program-share__icon--wechat"><i class="fa fa-weixin"></i></span>
            <span>微信</span>
          </button>
          <button class="mini-program-share__option" @click="shareToMiniProgram('timeline')">
            <span class="mini-program-share__icon mini-program-share__icon--timeline">朋</span>
            <span>朋友圈</span>
          </button>
          <!-- <button class="mini-program-share__option" @click="copyShareLink">
            <span class="mini-program-share__icon mini-program-share__icon--link"><i class="fa fa-link"></i></span>
            <span>复制链接</span>
          </button> -->
        </div>
        <button class="mini-program-share__cancel" @click="closeMiniProgramShare">取消</button>
      </div>
    </van-overlay>
    <router-link to="/index.html"><img src="../../assets/images/hjinexenter.png" alt="" class="to-index"></router-link>
    <DetailToTop></DetailToTop>
  </div>
</template>

<script>
import { verifyLoginStatus } from '@/utils/common'
import { connectWebViewJavascriptBridge } from '@/utils/OverallJsMobile'
import headers from '@/components/headers'
import { Row, Col, ImagePreview, Toast } from 'vant'
import DetailToTop from './template/detail-toTop.vue'
import search from '@/components/search'
import wxAuth from '@/components/wxAuth'
import { myriabit, getImageUrl } from '@/filters/commonFilters'
import list from '@/components/list'
import { getCMSData } from '@/api/common'
import { getBizFile, addDownloadCount, queryDownloadCount, queryFreeOrderExist, checkDownloadAuth, dealAwaitOrder, getOrderInfoByOrderNo, queryCreateOrderNo, creatOrderInfo, createOrder, getBizFileUrl } from '@/api/solutions/solution'
import { setCookie, getCookie, removeCookie } from '@/utils/cookies'
import { getUser, updateFreeDownLoadNum } from '@/api/user/user'
import { canUseFreeCaseDownload } from '@/utils/freeCaseDownload'
import { toLogin, isMobile } from '@/utils/common'
import shareGuideMask from './template/share_guide'
import downloadLimit from './template/download_limit'
import shareGuideDialog from './template/share_guide_dialog'
import { mapState } from 'vuex'
import miniProgramPayment from '@/mixins/miniProgramPayment'
export default {
  name: 'solution-detail',
  mixins: [miniProgramPayment],
  components: { Row, Col, wxAuth, headers, list, shareGuideMask, downloadLimit, shareGuideDialog, DetailToTop, search },
  filters: { myriabit, getImageUrl },
  computed: {
    ...mapState({
      token: state => state.user.ticket,
      // userId: state => state.user.AccountId,
      userName: state => state.user.AccountName,
      hotKeyWord: state => state.solution.keyWords
    }),
    isPreviewProtected() {
      return this.detail.openProtectMode === 1
    }
  },
  data() {
    return {
      //搜索
      searchParam: {
        type: 'search01',
        url: '/hadoop/list.html',
        placeholder: ''
      },
      //小能客服id
      id: '',
      //是否收藏
      showIcon: false,
      //是否显示展开按钮
      showChek: false,
      //定时器
      timers: '',
      //是否展开
      showImgList: true,
      // 限免截至时间
      curStartTime: "",
      // 是否限免
      showLimitFree: false,
      // 倒计时
      day: '0',
      hour: '00',
      min: '00',
      second: '00',
      // 计时器
      timer: '',
      //方案费用
      money: 0,
      share: {
        title: this.detail ? this.detail.solutionName : '解决方案馆',
        desc: this.detail ? this.detail.description : '智能化产品方案,产品方案,系统方案,弱电设备方案,厂商方案,产品供应商设计方案,弱电设计方案,热门方案,规划设计方案,顶层设计方案,系统解决方案,集成商方案,招标方案,投标方案,深化设计方案,施工方案',
        imgUrl: this.detail && this.detail.imageList.length > 0 ? this.detail.imageList[0] : 'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg',
        url: window.location.href.split('#')[0],
        callback: 'callback'
      },
      hraderP: {
        title: '方案详情',
        lefticon: true,
      },
      solutionId: '',
      date: '',
      detail: {}, // 方案详情
      params: {
        list: [],
        type: 'sol',
        total: null
      },
      buildingType: '',
      buildingTypeId: '',
      firstSysAttr: '',
      firstSysAttrId: '',
      user: null,

      source: null,
      code: undefined,
      queryData: {
        userId: null,
        businessType: 1,
        businessId: null
      },
      userId: null,
      isOverAjax: false,
      isCheckingDownload: false,
      isNativeApp: false,
      showMiniProgramShare: false,
      previewUrls: '',
      watermark: "{\"content\":\"img:https://wuyou-resource.oss-cn-shanghai.aliyuncs.com/waterMarkPPT.png\",\"width\":300,\"opacity\":0.2}",
      limit: 1,
      bizFile: []
    }
  },
  created() {
    this.isNativeApp = !!(($HMD$.rNavigator && ($HMD$.rNavigator.toLowerCase() === 'ios' || $HMD$.rNavigator.toLowerCase() === 'android')))
    this.userId = getCookie('accountId') || getCookie('AccountId')
    this.solutionId = this.$route.params.id
    this.date = this.$route.params.date
    this.buildingType = this.$route.query.buildingType
    this.buildingTypeId = this.$route.query.buildingTypeId
    this.firstSysAttr = this.$route.query.firstSysAttr
    this.firstSysAttrId = this.$route.query.firstSysAttrId
    this.queryData.userId = getCookie('accountId') || getCookie('AccountId')
    this.queryData.businessId = this.solutionId
    this.code = this.$route.query.code
    // this.code = this.$route.query.code ? this.$route.query.code : (window.location.search.indexOf('code%3D0') > 0 ? 0 : undefined)
    this.getData()
    this.getCMSData()
    if (!getCookie('AccountId') && !getCookie('accountId') && getCookie('ticket')) {
      this.setAccountId()
    }
  },
  async mounted() {
    await verifyLoginStatus()
    this.isOverAjax = !!(this.detail.id)
    this.source = getCookie('WY_HOMEDO_SOURCE')
    if (this.$route.query) {
      // 限免分享二维码
      if (this.source && this.source === 'LIMIT_FREE_SHARE') {
        this.$refs.shareGuide.show = true
        removeCookie('WY_HOMEDO_SOURCE')
      }
    }
    if (this.code != undefined) {
      if (this.code == 0) {
        Toast('支付成功')
      } else if (this.code == 1) {
        Toast('支付失败')
      } else if (this.code == 2) {
        Toast('支付处理中')
      }
      if ($HMD$.rNavigator.toLowerCase() === 'ios') {
        this.iosReturnPage()
      }
    }
    if (!isMobile()) {
      window.location.href = `${process.env.PC_SOLUTION_URL || '//solution.homedo.com/'}/solutions/detail/${this.solutionId}.html`
    }
    this.$store.dispatch('SOLUTIONS_GET_KEYWORD')
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.timers);
  },
  watch: {
    $route(to, from) {
      this.$data.solutionId = to.params.id
      this.getData()
    },
    hotKeyWord(newV, old) {
      if (newV && newV.length > 0) {
        this.$data.searchParam.placeholder = newV
      }
    }
  },
  methods: {
    // 方案附件的下载权限与底部下载按钮保持一致；无下载权限时仅预览附件。
    handleAttachmentClick(item, index) {
      console.log('item', item, 'index', index)
      if (this.detail.seckillFlag) {
        this.updownloadBtn()
      } else if (this.detail.isAdmitDownload && (!this.detail.charges || this.detail.charges <= 0)) {
        this.handleBatchDownload()
      } else if (this.detail.isAdmitDownload && this.detail.activityFreeStatus === 'PROCEED') {
        this.handleBatchDownload()
      } else if (!(+this.detail.isAdmitDownload)) {
        this.getImg(item, index)
      } else {
        this.updownloadBtn()
      }
    },
    // 底部“分享即可免费下载”仅在小程序 WebView 中展示分享面板；其他端沿用原下载流程。
    handleShareDownload() {
      if (this.isMiniProgram()) {
        this.showMiniProgramShare = true
        return
      }
      this.handleBatchDownload()
    },
    closeMiniProgramShare() {
      this.showMiniProgramShare = false
    },
    shareToMiniProgram(shareTo) {
      const miniProgram = (window.wx && window.wx.miniProgram) || (this.$wx && this.$wx.miniProgram)
      if (!miniProgram || typeof miniProgram.postMessage !== 'function') {
        Toast('当前环境暂不支持分享')
        return
      }
      miniProgram.postMessage({
        data: {
          event: 'solutionShare',
          shareTo,
          solutionId: this.solutionId,
          title: this.share.title,
          desc: this.share.desc,
          imageUrl: this.share.imgUrl,
          url: this.share.url
        }
      })
      this.closeMiniProgramShare()
      Toast('已发起分享')
    },
    copyShareLink() {
      const input = document.createElement('input')
      input.value = this.share.url
      input.setAttribute('readonly', '')
      input.style.position = 'fixed'
      input.style.opacity = '0'
      document.body.appendChild(input)
      input.select()
      const copied = document.execCommand('copy')
      document.body.removeChild(input)
      if (copied) {
        this.closeMiniProgramShare()
        Toast.success('链接已复制')
      } else {
        Toast('复制失败，请手动复制链接')
      }
    },
    //查看更多
    chekMore() {
      if (this.isPreviewProtected) {
        return
      }
      if (!getCookie('ticket') && $HMD$.rNavigator !== 'msite') {
        // 跳转登录页面
        toLogin()
      } else if ($HMD$.rNavigator === 'msite' && (!getCookie('AccountId') && !getCookie('accountId'))) {
        toLogin()
      } else {
        this.limit = 0
        this.showChek = false
        // let vanCol = this.$refs.vanCol.$el.offsetHeight;
        // let divImg = this.$refs.vanImg.offsetHeight;
        // if(vanCol<divImg && this.showImgList){
        //   this.$refs.vanCol.$el.style.maxHeight = divImg+'px'
        // } else if(vanCol == divImg && !this.showImgList) {
        //   this.$refs.vanCol.$el.style.maxHeight = 500+'px'
        // }
        // this.$refs.vanCol.$el.offsetHeight<this.$refs.vanImg.offsetHeight?this.showImgList =true : this.showImgList = false
      }
    },
    //获取cms数据id
    getCMSData() {
      getCMSData().then((res) => {
        if (res.data && res.data.respCode === '0000') {
          this.id = res.data.data.customerService.id || ''
        }
      })
    },
    //客服
    kefu() {
      if ($HMD$.rNavigator == 'ios' || $HMD$.rNavigator == 'android') {
        $HMD$.M.sendApp({
          name: 'qaOnline',
          value: this.id
        })
      } else {
        $HMD$.M.lineXN(this.id, true)//为true时，就算用户已登录有分配客服，也以页面指定客服为主
      }
    },
    //收藏
    collection(index) {
      const data = {
        "isCollect": index === 1,
        "solutionId": this.solutionId,
        "userId": this.userId
      }
      this.$store.dispatch('SOLUTIONS_POST_COLLECT', data).then((res) => {
        if (res.status === 200 && res.data.code === 460) {
          // 跳转登录页面
          toLogin()
        } else if (res.status === 200 && res.data.respCode === '0000') {
          index === 1 ? this.showIcon = true : this.showIcon = false
        } else {
          Toast(res.data.respDesc)
        }
      })
    },
    // 倒计时
    countTime() {
      if (!this.showLimitFree) return
      // 获取当前时间
      let now = this.nowTime
      // 设置截止时间
      let endDate = new Date(this.curStartTime.toString().replace(/-/g, '/')) // this.curStartTime需要倒计时的日期
      let end = endDate.getTime()
      // 时间差
      let leftTime = end - now
      // 定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        // 天
        this.day = Math.floor(leftTime / 1000 / 60 / 60 / 24)
        // 时
        let h = Math.floor(leftTime / 1000 / 60 / 60 % 24)
        this.hour = h < 10 ? '0' + h : h
        // 分
        let m = Math.floor(leftTime / 1000 / 60 % 60)
        this.min = m < 10 ? '0' + m : m
        // 秒
        let s = Math.floor(leftTime / 1000 % 60)
        this.second = s < 10 ? '0' + s : s
      } else {
        this.day = 0
        this.hour = '00'
        this.min = '00'
        this.second = '00'
      }
      // 等于0的时候不调用
      if (Number(this.hour) === 0 && Number(this.day) === 0 && Number(this.min) === 0 && Number(this.second) === 0) {
        return
      } else {
        this.nowTime = this.nowTime + 1000
        // 递归每秒调用countTime方法，显示动态时间效果,
        this.timer = setTimeout(this.countTime, 1000)
      }
    },
    async setAccountId() {
      let accountId = await this.getAppAccountId()
      if (!accountId) return
      if (!this.userId) {
        this.userId = accountId
      }
      if (!this.queryData.userId) {
        this.queryData.userId = accountId
      }
    },
    // 原生APP 调用分享
    iosReturnPage() {
      let _this = this
      connectWebViewJavascriptBridge(function (bridge) {
        bridge.registerHandler('callHDBridgeHandler', function (message, responseCallback) {
          let jsonMessage = JSON.parse(message)
          if (typeof (jsonMessage.name) !== 'undefined' && jsonMessage.name === 'payCanBack') {
            let data = {
              'name': 'toHome',
            }
            // 调用原生方法
            bridge.callHandler('registerHDBridgeHandler', data, function (response) { })
          }
        })
      })
    },
    appShare() {
      let _this = this
      $HMD$.M.Ready(function () {
        $HMD$.M.returnApp('requestShare', function () {
          $HMD$.M.sendApp({
            'name': 'activityshare',
            'value': _this.share.url,
            'title': _this.share.title,
            'count': '',
            'type': '',
            'promtion': '',
            'dict': JSON.stringify({
              Subtitle: _this.share.title,
              shareImg: _this.share.imgUrl,
              activityName: _this.share.title,
              activityId: 0
            })
          })
        })
      })
    },
    getData() {
      if (!this.solutionId || this.solutionId === 'undefined') {
        this.isOverAjax = true
        return
      }
      let self = this
      self.$store.dispatch('SOLUTIONS_GET_DETAILANDUSERID', { id: this.solutionId, userId: this.userId }).then(result => {
        this.isOverAjax = true
        if (result.status === 200 && result.data && result.data.code === 200 && result.data.data) {
          console.log(result.data.data, 'datadata')
          self.getFile(result.data.data.solutionId)
          self.detail = result.data.data
          console.log('[方案详情接口] isFree 字段', {
            value: self.detail.isFree,
            type: typeof self.detail.isFree,
            charges: self.detail.charges,
            solutionId: self.detail.solutionId
          })
          self.showIcon = self.detail.collect
          this.money = self.detail.charges ? self.detail.charges : '0'
          if (self.detail.activityFreeStatus === 'PROCEED') {
            self.share.title = '【限时免费下载】' + self.detail.solutionName
            this.showLimitFree = true
            this.curStartTime = self.detail.activityFreeendTime
            this.nowTime = self.detail.nowTime ? (new Date(self.detail.nowTime.toString().replace(/-/g, '/')) || new Date()).getTime() : new Date().getTime()
            this.countTime()
          } else {
            self.share.title = self.detail.solutionName
          }
          self.share.desc = self.detail.description
          self.share.imgUrl = self.detail && self.detail.pics.length > 0 ? self.detail.pics[0].url : 'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg'
          if ($HMD$.rNavigator.toLowerCase() === 'ios' || $HMD$.rNavigator.toLowerCase() === 'android') {
            this.appShare()
          }
          try {
            this.$refs.child.wxAuth()
          } catch (e) {
            console.log(e)
          }
        }
      })
      self.$store.dispatch('SOLUTIONS_GET_RELATED_SOL', this.solutionId).then(result => {
        if (result.status === 200 && result.data && result.data.code === 200 && result.data.data) {
          self.params.list = [...result.data.data.list]
        }
      })

      let accountId = getCookie('accountId') ? getCookie('accountId') : getCookie('AccountId')
      if (accountId) {
        getUser(accountId).then(result => {
          if (result.status === 200 && result.data && result.data.respCode === '0000') {
            this.user = result.data.data
          }
        })
      }
    },
    getFile(id) {
      getBizFileUrl(id).then(result => {
        this.bizFile = result.data.data.records || []
        console.log(this.getFirstValidFileUrl(this.bizFile), '1231')
        // this.previewUrls = this.bizFile.length>0? this.bizFile[0].url.includes('http')?this.bizFile[0].url:'https:'+this.bizFile[0].url:''
        this.previewUrls = this.bizFile.length > 0 ? this.getFirstValidFileUrl(this.bizFile) : ''
        this.timers = setTimeout(() => {
          const heightA = this.$refs.vanImg.offsetHeight;
          heightA > 200 ? this.showChek = true : this.showChek = false
        }, 500);
      })
    },
    /**
     * 从文件URL数组中获取第一个符合允许格式的文件URL
     * @param {string[]} urls - 文件URL数组
     * @returns {string|null} 第一个匹配的文件URL，若未找到则返回null
     */
    getFirstValidFileUrl(urls) {
      // 允许的文件扩展名列表（小写）
      const allowedExtensions = new Set([
        'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'ofd',
        'zip', 'rar', 'txt', 'rtf', 'jpg', 'tiff', 'mp4', 'mp3'
      ]);
      // 遍历URL数组，按顺序查找第一个匹配项
      for (const item of urls) {
        const ext = this.getFileExtension(item.url);
        if (allowedExtensions.has(ext)) {
          return item.url.includes('http') ? item.url : 'https:' + item.url; // 返回第一个匹配的URL
        }
      }
      return null; // 未找到匹配项
    },
    /**
     * 从URL中提取文件扩展名（小写）
     * @param {string} url - 文件URL
     * @returns {string} 扩展名（不含点），若无扩展名则返回空字符串
     */
    getFileExtension(url) {
      // 去除查询参数和哈希片段
      let cleanUrl = url.split('?')[0].split('#')[0];
      // 获取最后一个点之后的部分
      const lastDotIndex = cleanUrl.lastIndexOf('.');
      if (lastDotIndex === -1 || lastDotIndex === cleanUrl.length - 1) {
        return '';
      }
      return cleanUrl.slice(lastDotIndex + 1).toLowerCase();
    },
    preview(url) {
      ImagePreview([getImageUrl(url)])
    },
    getImg(item, index) {
      this.limit = 1
      this.showChek = true
      if (!this.isValidFileUrl(this.bizFile[index].url)) {
        return
      }
      this.previewUrls = this.bizFile[index].url ? this.bizFile[index].url.includes('http') ? this.bizFile[index].url : 'https:' + this.bizFile[index].url : ''
      // this.detail.pics = []
      // getBizFile(item.id).then(result => {
      //   if (result.data && result.data.respCode === '0000' && result.data.data) {
      //     this.detail.pics = result.data.data.records
      //   }
      // })
    },
    /**
     * 检查单个文件URL是否符合允许的扩展名格式
     * @param {string} url - 文件URL
     * @returns {boolean} - 符合格式返回true，否则返回false
     */
    isValidFileUrl(url) {
      // 允许的文件扩展名列表（小写）
      const allowedExtensions = new Set([
        'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'ofd',
        'zip', 'rar', 'txt', 'rtf', 'jpg', 'tiff', 'mp4', 'mp3'
      ]);

      // 参数校验
      if (typeof url !== 'string' || url.trim() === '') {
        return false;
      }

      // 去除查询参数和哈希片段，获取纯文件路径
      let cleanUrl = url.split('?')[0].split('#')[0];

      // 提取扩展名（最后一个点之后的部分）
      const lastDotIndex = cleanUrl.lastIndexOf('.');
      if (lastDotIndex === -1 || lastDotIndex === cleanUrl.length - 1) {
        return false; // 无扩展名或扩展名为空
      }

      const ext = cleanUrl.slice(lastDotIndex + 1).toLowerCase();
      return allowedExtensions.has(ext);
    },
    handleBatchDownload: async function () {
      if (!getCookie('ticket') && $HMD$.rNavigator !== 'msite') {
        // 跳转登录页面
        toLogin()
      } else if ($HMD$.rNavigator === 'msite' && (!getCookie('AccountId') && !getCookie('accountId'))) {
        toLogin()
      } else {
        let userId = getCookie('AccountId') || getCookie('accountId')
        if ($HMD$.rNavigator !== 'msite' && !userId) {
          userId = await this.getAppAccountId()
        }
        if (userId === `${this.detail.userId}` || getCookie('accountId') === `${this.detail.userId}`) {
          this.$router.push(`/download/${this.solutionId}.html`)
          return
        }
        if (this.detail.activityFreeStatus === 'PROCEED') {
          this.limitFreeSolution()
        } else {
          Toast.loading({
            message: '下载中...',
            forbidClick: true
          })
          this.freeSolution()
        }
      }
    },
    /**
     * 分享完成
     */
    shareFinish(event) {
      if (this.source === 'LIMIT_FREE_SHARE' && event.type === 'success') {
        this.$router.push(`/shareFinish/${this.solutionId}/${this.detail.activityId}.html`)
      }
    },
    /**
     * 限免方案下载
     */
    limitFreeSolution() {
      // 查询是否创建过限免订单
      queryFreeOrderExist(this.solutionId).then(result => {
        if (result.status === 200 && result.data && result.data.code === 460) {
          // 登录失效
          toLogin()
          return
        }
        if (result.status === 200 && result.data && result.data.respCode === '0000' && result.data.data) {
          if (result.data.data.flag) {
            this.$router.push(`/download/${this.solutionId}.html`)
          } else {
            this.$refs.shareGuideDialog.bizId = this.solutionId
            this.$refs.shareGuideDialog.activeId = this.detail.activityId
            this.$refs.shareGuideDialog.show = true
          }
        } else {
          this.$refs.shareGuideDialog.bizId = this.solutionId
          this.$refs.shareGuideDialog.activeId = this.detail.activityId
          this.$refs.shareGuideDialog.show = true
        }
      })
    },
    /**
     * 免费方案下载
     */
    async freeSolution() {
      // 查询下载次数
      let userId = getCookie('accountId') ? getCookie('accountId') : getCookie('AccountId')
      if ($HMD$.rNavigator !== 'msite' && !userId) {
        userId = await this.getAppAccountId()
      }
      const downloadCountForm = {
        userId: userId,
        bizType: 'solution_download',
        bizId: this.solutionId
      }
      queryDownloadCount(downloadCountForm).then(count => {
        if (count.status === 200 && count.data && count.data.respCode === '0000' && count.data.data) {
          if (count.data.data.isAllowDownload) {
            // 允许下载
            const form = {
              businessId: [
                this.solutionId
              ],
              businessType: 'solution',
              userId: userId
            }
            addDownloadCount(form).then(result => {
              if (result.status === 200 && result.data) {
                if (result.data.respCode === '0000') {
                  // 跳转下页面
                  this.$router.push(`/download/${this.solutionId}.html`)
                } else {
                  Toast.fail(result.data.respDesc)
                }
              }
            })
          } else {
            // 不允许下载
            Toast.clear()
            this.$refs.downloadLimit.orderStatusText = '免费'
            this.$refs.downloadLimit.show = true
          }
        }
      })
    },
    /**
     * 立即分享
     * @param event
     */
    shareGuideDialogCallback(event) {
      if (event) {
        this.source = 'LIMIT_FREE_SHARE'
        this.$refs.shareGuide.show = true
      }
    },
    async checkDownload() {
      //  20：待付款 30：付款完成 40：支付失败 50：已取消 60：待审核 70 审核失败
      // 2 -处理中 3-线下支付待审核 ,
      if ($HMD$.rNavigator !== 'msite' && !this.queryData.userId) {
        this.queryData.userId = await this.getAppAccountId()
      }
      checkDownloadAuth(this.queryData).then(res => {
        if (res.status == 200 && res.data.respCode == '0000') {
          if (res.data.data && res.data.data.plusUser == 1) {
            // 跳转下载页面
            this.$router.push(`/downloadFree/${this.detail.solutionId}.html`)
          } else if (res.data.data && res.data.data.status == 30) {
            // 跳转下载页面
            this.$router.push(`/downloadFree/${this.detail.solutionId}.html`)
          } else {
            let backUrl = window.location.href
            this.$router.push(`/solutionDownload.html?businessId=${this.detail.solutionId}&businessName=${this.detail.solutionName}&backUrl=${encodeURIComponent(backUrl)}&total=${this.detail.charges}`)
          }
        } else {
          Toast('抱歉，下载权限校验失败!')
        }
      })
    },
    // 下载源文件按钮
    async updownloadBtn() {
      if (this.isCheckingDownload) return
      console.log('[updownloadBtn] detail快照', JSON.stringify(this.detail))
      console.log('[updownloadBtn] isFree', this.detail && this.detail.isFree)
      console.log('[updownloadBtn] solutionId', this.detail && this.detail.solutionId)
      if (!getCookie('ticket') && $HMD$.rNavigator !== 'msite') {
        // 跳转登录页面
        // $HMD$.M.sendApp({
        //   name: 'login',
        //   value: true
        // })
        toLogin()
      } else if ($HMD$.rNavigator === 'msite' && (!getCookie('accountId') && !getCookie('AccountId'))) {
        toLogin()
      } else {
        this.isCheckingDownload = true
        try {
          if (!this.detail.isFree) {
            // 跳转下载页面
            this.$router.push(`/downloadFree/${this.detail.solutionId}.html`)
          } else {
            await this.checkOrder()
          }
        } catch (error) {
          Toast.fail(error.message || '下载权限查询失败，请稍后重试')
        } finally {
          this.isCheckingDownload = false
        }
      }
    },
    async tryFreeCaseDownload() {
      if (!canUseFreeCaseDownload(this.detail)) return false
      const result = await getUser(this.queryData.userId)
      if (!result || result.status !== 200 || !result.data || result.data.respCode !== '0000' || !result.data.data) {
        throw new Error('用户免费下载次数查询失败')
      }
      this.user = result.data.data
      if (!(Number(this.user.freeCaseDownloadCount) > 0)) return false
      // 在详情页使用免费次数，更新成功后进入普通下载完成页。
      let updateResult
      try {
        updateResult = await updateFreeDownLoadNum({ userId: this.queryData.userId })
      } catch (error) {
        throw new Error('免费下载次数更新失败，请稍后重试')
      }
      if (!updateResult || updateResult.status !== 200 || !updateResult.data ||
          !(updateResult.data.respCode === '0000' || updateResult.data.code === 200)) {
        throw new Error('免费下载次数更新失败，请稍后重试')
      }
      this.user.freeCaseDownloadCount = Math.max(0, Number(this.user.freeCaseDownloadCount) - 1)
      this.$router.push(`/download/${this.detail.solutionId}.html`)
      return true
    },
    getAppAccountId() {
      return new Promise((resolve, reject) => {
        $HMD$.GetLogin(function (data) {
          if (data && data.AccountId) {
            setCookie('accountId', data.AccountId)
          }
          resolve(data && data.AccountId || '')
        })
      });
    },
    startNewOrderFlow() {
      if (this.detail.seckillFlag) {
        this.createBuy(this.detail)
        return
      }
      let backUrl = window.location.href
      this.$router.push(`/solutionDownload.html?businessId=${this.detail.solutionId}&businessName=${this.detail.solutionName}&backUrl=${encodeURIComponent(backUrl)}&total=${this.detail.charges}`)
    },
    // 校验订单
    async checkOrder() {
      //  查询当前业务的支付状态
      //  待支付---》 收银台
      //  未支付---》
      //  20：待付款 30：付款完成 40：支付失败 50：已取消 60：待审核 70 审核失败
      // 2 -处理中 3-线下支付待审核 ,
      this.queryData.userId = getCookie('accountId') || getCookie('AccountId')
      this.queryData.businessId = this.solutionId
      if ($HMD$.rNavigator !== 'msite' && !this.queryData.userId) {
        this.queryData.userId = await this.getAppAccountId()
      }
      let orderStatus = await checkDownloadAuth(this.queryData)
      if (orderStatus.data.respCode === '0000' && orderStatus.status === 200) {
        if (orderStatus.data.data && orderStatus.data.data.plusUser == 1) {
          // 跳转下载页面
          this.$router.push(`/downloadFree/${this.detail.solutionId}.html`)
        } else if (orderStatus.data.data && orderStatus.data.data.status == 30) {
          // 已付款的方案不消耗免费下载次数。
          this.$router.push(`/downloadFree/${this.detail.solutionId}.html`)
        } else if (await this.tryFreeCaseDownload()) {
          return
        } else if (orderStatus.data.data && !orderStatus.data.data.hasPayOrder) {
          // 无订单
          this.startNewOrderFlow()
        } else {
          if (orderStatus.data.data) {
            var orStatus = orderStatus.data.data.status
            var payStatus = orderStatus.data.data.payStatus
            switch (orStatus) {
              case 20:
                // 支付待审核
                if (payStatus) {
                  if (payStatus == 2) {
                    this.doAwaitOrder(orderStatus.data.data.orderNo)
                  }
                  if (payStatus == 3) {
                    Toast('当前订单审核中，请稍等！')
                  }
                  if (payStatus == 1) {
                    this.doAwaitOrder(orderStatus.data.data.orderNo)
                  }
                } else {
                  this.doAwaitOrder(orderStatus.data.data.orderNo)
                }
                break
              case 30:
                // 跳转下载页面
                this.$router.push(`/downloadFree/${this.detail.solutionId}.html`)
                break
              case 40:
                this.doAwaitOrder(orderStatus.data.data.orderNo)
                break
              case 50:
                // 已取消订单不具备下载权限，重新走下单流程。
                this.startNewOrderFlow()
                break
              case 60:
                this.doAwaitOrder(orderStatus.data.data.orderNo)
                break
              case 70:
                this.doAwaitOrder(orderStatus.data.data.orderNo)
                break
            }
          }
        }
      }
    },
    async doAwaitOrder(orderNo) {
      let param = {
        businessId: this.detail.solutionId,
        businessName: this.detail.solutionName,
        businessType: this.detail.solutionType,
        userId: getCookie('accountId') || getCookie('AccountId'),
        os: $HMD$.rNavigator && $HMD$.rNavigator == 'msite' ? 'wap' : $HMD$.rNavigator,
        // returnUrl : 'https://pay.' + $HMD$.rApi.S + 'homedo.com/Cashier/FrontReturnCallback',
        orderNo: orderNo
      }
      if ($HMD$.rNavigator !== 'msite' && !param.userId) {
        param.userId = await this.getAppAccountId()
      }
      dealAwaitOrder(orderNo, param).then(res => {
        if (res.status === 200 && res.data.respCode === '0000') {
          if (this.isMiniProgram()) {
            this.getOrderIdToMiniProgram(orderNo)
          } else if (window.$HMD$.rNavigator.toLowerCase() === 'ios') {
            this.getOrderIdToIos(orderNo, res.data.data.url)
          } else {
            window.location.href = res.data.data.url
          }
        } else {
          Toast('抱歉，下载权限校验失败!')
        }
      })
    },
    getOrderIdToIos(orderNo, jumpUrl) {
      getOrderInfoByOrderNo(orderNo).then((res) => {
        if (res.data.code !== 1000 && res.data.msg === '处理成功') {
          // eslint-disable-next-line no-undef
          $HMD$.M.sendApp({
            'name': 'FangAnGuanOrderId',
            'orderId': res.data.code && res.data.code.toString()
          })
        }
        window.location.href = jumpUrl
      })
    },
    async createBuy(item) {
      await this.getCreateOrderNo()
      this.ajaxNum = 0
      this.postCreatOrderInfo(item)
    },
    // 获取平台唯一销售订单编号orderNo
    async getCreateOrderNo() {
      let res = await queryCreateOrderNo()
      if (res.status !== 200) {
        return
      }
      if (res.data.respCode !== '0000') {
        return
      }
      this.orderNo = res.data.respDesc
    },
    // 创建平台订单信息
    async postCreatOrderInfo(item) {
      let postData = {
        amount: item.seckill,
        hebiAmount: 0,
        // orderNo: this.orderNo,
        businessId: item.solutionId,
        businessName: item.solutionName,
        businessType: 1,
        couponAmount: 0,
        os: $HMD$.rNavigator && $HMD$.rNavigator == 'msite' ? 'wap' : $HMD$.rNavigator,
        userId: getCookie('accountId') || getCookie('AccountId'),
        orderNo: this.orderNo
      }
      if ($HMD$.rNavigator !== 'msite' && !postData.userId) {
        postData.userId = await this.getAppAccountId()
      }
      creatOrderInfo(postData).then(res => {
        if (res.data && res.data.respCode === '0000') {

        } else {
          // Toast(res.data.respDesc, '服务异常')111
        }
      })
      this.queryOrderInfoByOrderNo(postData)
    },
    // 轮询接口,前端调用的查缓存接口
    async queryOrderInfoByOrderNo(postData) {
      let t = setInterval(() => {
        this.ajaxNum += 1
        getOrderInfoByOrderNo(postData.orderNo).then((res) => {
          if (this.ajaxNum > 9) {
            this.toast.clear()
            clearInterval(t)
          }
          if (res.data.code !== 1000 && res.data.msg === '处理成功') {
            clearInterval(t)
            this.orderId = res.data.code
            this.createNewOrderLast(postData)
          }
        })
      }, 1000)
    },
    // 创建订单,页面跳转
    async createNewOrderLast(postData) {
      postData.orderNo = this.orderId
      createOrder(postData).then(count => {
        this.toast.clear()
        if (postData.amount === 0 && count.status === 200 && count.data && count.data.respCode === '0000') {
          this.$router.push(`/solutions/detail/${postData.businessId}.html`)
          return
        }
        if (count.status !== 200) {
          Toast('请检查网络')
          return
        }
        if (count.status === 200 && count.data && count.data.respCode !== '0000') {
          Toast(count.data.respDesc)
          return
        }
        if (count.status === 200 && count.data && count.data.respCode === '0000') {
          if (this.isMiniProgram()) {
            this.redirectToMiniProgramPayment(this.orderId)
            return
          }
        }
        if (count.status === 200 && count.data && count.data.respCode === '0000' && count.data.data && count.data.data.url) {
          // eslint-disable-next-line no-undef
          if ($HMD$.rNavigator.toLowerCase() === 'ios') {
            // eslint-disable-next-line no-undef
            $HMD$.M.sendApp({
              'name': 'FangAnGuanOrderId',
              'orderId': this.orderId && this.orderId.toString()
            })
          }
          window.location.href = count.data.data.url
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.solution-detail-bkg {
  background-color: #efeff4;

  .solution-detail-row {
    background-color: white;
    padding-left: 3%;
    padding-right: 3%;

    .item-price {
      font-size: 10px;
    }

    .item-limitFree {
      font-size: 10px;
    }

    .item-title {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-top: 10px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: bold;
      font-size: 16px;
      color: #222222;
    }

    .item-type {
      padding-top: 5px;
      font-size: 10px;
      color: #2177FF;

      &-date {
        text-align: right;
        padding-top: 5px;
        font-size: 10px;
        color: #a0a0a0;
      }
    }

    &.solution-first-row {
      padding-bottom: 15px;
      box-sizing: border-box;
    }

    &.item-describe-price {
      font-size: 10px;
      background-color: #e6eefc;
      padding: 0 3%;
      box-sizing: border-box;
    }

    &.item-describe-row {
      margin-bottom: 10px;
      padding-bottom: 15px;
      padding-top: 15px;

      .item-describe {
        background-color: #f5f9fa;
        padding: 10px;
        font-size: 13px;
        color: #666666;
      }
    }

    &-label {
      background-color: white;
      font-size: 16px;
      height: 40px;
      line-height: 40px;
      padding: 0 15px;
      border-bottom: 1px solid #D8D8D8;
      box-sizing: border-box;

      .item-label::before {
        display: inline-block;
        vertical-align: middle;
        content: '';
        width: 2px;
        height: 16px;
        background-color: #1dbfda;
        margin-right: 5px;
        margin-top: -2px;
      }

      .batch_download {
        text-align: right;

        span {
          padding: 0 8px;
          display: inline-block;
          height: 22px;
          line-height: 22px;
          font-size: 12px;
          border: 1px solid #1dbfda;
          color: #1dbfda;
          border-radius: 4px;
        }
      }
    }

    &-pdf {
      background-color: white;
      padding-left: 20px;
      padding-right: 3%;
      height: 40px;
      line-height: 40px;

      .item-file-or-brand {
        font-size: 13px;
        color: #222222;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-decoration: underline;
      }

      .item-brand-right {
        color: #a0a0a0;
      }
    }

    &-fils {
      padding-bottom: 15px;
      margin-bottom: 10px;
    }

    .item-img {
      max-height: 500px;
      overflow: hidden;
      padding-top: 15px;
    }

    .chek {
      width: 100%;
      height: 30px;
      text-align: center;

      .img {
        -webkit-transform: rotate(180deg);
        -moz-transform: rotate(180deg);
        -o-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        transform: rotate(180deg);
      }

      span {
        color: #2F7BFF;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        position: relative;
        top: 0.05rem;
      }
    }

    .chek--disabled {
      opacity: 0.5;
      pointer-events: none;
    }

    .related-item {
      padding-top: 15px;
      padding-bottom: 15px;
      border-bottom: 1px solid #D8D8D8;

      &:last-child {
        border-bottom: none;
      }

      img {
        width: 90px;
        height: 60px;
      }

      .title {
        height: 40px;
        text-overflow: ellipsis;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }

  .sub-demand-btn {
    position: fixed;
    bottom: 0.15rem;
    left: 3.2rem;
    right: 0;
    width: 30%;
    height: 1.1rem;
    font-size: 0.4rem;
    color: #222222;
    border: none;
    border-radius: 1.5rem 0 0 1.5rem;
    background-color: #E8F1FF;
  }

  .sub-download-btn {
    position: fixed;
    bottom: 0.15rem;
    left: 6.2rem;
    width: 35%;
    height: 1.1rem;
    font-size: 0.4rem;
    color: #ffffff;
    border: none;
    border-radius: 0 2rem 2rem 0;
    background-color: #288cfe;
  }

  .sub-demand {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 1.5rem;
    background: #ffffff;
  }

  .sub-demand-collection div {
    width: 1.5rem;
    height: 1.5rem;
  }

  .sub-demand-collection img {
    width: 0.5rem;
    height: 0.5rem;
    position: fixed;
    bottom: 0.7rem;
    left: 0.75rem;
  }

  .sub-demand-kefu img {
    width: 0.5rem;
    height: 0.5rem;
    position: fixed;
    bottom: 0.5rem;
    padding-bottom: .2rem;
    left: 2rem;
  }

  .sub-demand-kefu span {
    font-size: 0.25rem;
    position: fixed;
    left: 1.75rem;
    bottom: 0.2rem;
    width: 1rem;
    text-align: center;
  }

  .sub-demand-collection span {
    font-size: 0.25rem;
    position: fixed;
    left: 0.5rem;
    bottom: 0.2rem;
    width: 1rem;
    text-align: center;
  }

  .read {
    .span1 {
      font-size: 10px;
      color: #a0a0a0;
    }

    .span {
      margin-left: 200px;
      font-size: 10px;
      color: #f8a325;
    }
  }

  .download-guide {
    font-size: 16px;
    color: #ff7a00;
    padding-bottom: 5px;
    text-align: center;

    img {
      width: 44px;
      margin-top: 15px;
      margin-bottom: 15px;
    }
  }
}

.mini-program-share {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fff;
  text-align: center;

  &__title {
    height: 1.2rem;
    line-height: 1.2rem;
    font-size: 0.48rem;
    font-weight: 600;
    color: #222;
    border-bottom: 1px solid #f2f2f2;
  }

  &__options {
    display: flex;
    justify-content: space-around;
    padding: 0.55rem 0 0.48rem;
  }

  &__option {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 2rem;
    padding: 0;
    color: #666;
    font-size: 0.36rem;
    line-height: 0.6rem;
    border: 0;
    background: transparent;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 0.92rem;
    height: 0.92rem;
    margin-bottom: 0.16rem;
    border-radius: 50%;
    color: #fff;
    font-size: 0.54rem;

    &--wechat {
      background: #25c15b;
    }

    &--timeline {
      background: #ff9d2e;
      font-size: 0.42rem;
      font-weight: 600;
    }

    &--link {
      background: #338ff0;
      transform: rotate(-35deg);
    }
  }

  &__cancel {
    width: 100%;
    height: 1.2rem;
    padding: 0;
    color: #222;
    font-size: 0.46rem;
    border: 0;
    border-top: 0.16rem solid #f5f5f5;
    background: #fff;
  }
}

.bottom-style {
  height: 50px;
  width: 100%;
}

.home-header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9;
}

.margin-top-10 {
  margin-top: 10px;
}

.to-index {
  width: 122px;
  position: fixed;
  right: 16px;
  bottom: 63px;
}

.home-page {
  width: 3rem;
  position: fixed;
  bottom: 1.7rem;
  left: 6.6rem;
}

.fiexd {
  width: 100%;
  height: 1.2rem;
  background-color: #f5f5f5;
  position: fixed;
  z-index: 8;

  /deep/ .search-content .search-1-row {
    margin-top: 0.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/solutions/detail.vue